import * as views from '@/app/views';
import alertRoutes from '@/modules/alert/router';
import assetRoutes from '@/modules/asset/router';
import { AuthGuard } from '@/modules/auth/router/auth.guard';
import authRoutes from '@/modules/auth/router/auth.routes';
import dataCheckinRoutes from '@/modules/data-checkin/router';
import dataModelRoutes from '@/modules/data-model/router';
import dataSpaceManagementRoutes from '@/modules/data-space-management/router';
import notificationRoutes from '@/modules/notification/router';
import organizationRoutes from '@/modules/organization/router';
import retrievalRoutes from '@/modules/retrieval/router';
import searchRoutes from '@/modules/search/router';
import sharingRoutes from '@/modules/sharing/router';
import userRoutes from '@/modules/user/router';
import workflowRoutes from '@/modules/workflow-designer/router';
import { VueConstructor } from 'vue';

const routes = [
    {
        name: 'home',
        path: '/',
        component: views.Home as VueConstructor<Vue>,
        meta: { title: 'Home' },
    },
    {
        name: 'overview',
        path: '/overview',
        component: views.Overview as VueConstructor<Vue>,
        meta: { title: 'Overview' },
        beforeEnter: AuthGuard,
    },
    {
        name: 'about',
        path: '/about',
        component: views.About as VueConstructor<Vue>,
        meta: { title: 'About' },
    },
    {
        name: '500',
        path: '/500',
        component: views.Error500 as VueConstructor<Vue>,
        meta: { title: '500' },
    },
    {
        name: '503',
        path: '/503',
        component: views.Error503 as VueConstructor<Vue>,
        meta: { title: '503' },
    },
    {
        name: '404',
        path: '/404',
        component: views.Error404 as VueConstructor<Vue>,
        meta: { title: '404' },
    },
    ...authRoutes,
    ...dataCheckinRoutes,
    ...assetRoutes,
    ...userRoutes,
    ...organizationRoutes,
    ...searchRoutes,
    ...dataModelRoutes,
    ...notificationRoutes,
    ...workflowRoutes,
    ...retrievalRoutes,
    ...alertRoutes,
    ...sharingRoutes,
    ...dataSpaceManagementRoutes,
    // 404 route must be last
    {
        path: '*',
        redirect: { name: '404' },
    },
];

export default routes;
